import { useApplicationServerContext } from '../../state';
import { type ErrorServerState } from '../../state/server';
import { Error as ErrorComponent } from './Error';

export function Error() {
  const [state] = useApplicationServerContext() as [ErrorServerState];

  return (
    <ErrorComponent
      title={state.error}
      description={state.errorDescription}
      traceparent={state.traceparent}
    />
  );
}
